<template>
  <ClientHistorySection
    title="Historique client"
    context="quote-client"
    storage-key="historique-client-info"
    :calls="calls"
    :loading-calls="loading"
    :sent-emails="sentEmails"
    :upcoming-emails="upcomingEmails"
    :loading-emails="loading"
    :loading-upcoming-emails="loading"
    :format-date-with-default="formatDateWithDefault"
  />
</template>

<script setup>
import { toRef } from 'vue'
import ClientHistorySection from '../shared/ClientHistorySection.vue'
import { useQuoteClientHistory } from '../../composables/quotes/useQuoteClientHistory.js'
import { formatDate } from '../../utils/dateFormatters.js'

const props = defineProps({
  email: {
    type: String,
    default: ''
  },
  siret: {
    type: String,
    default: ''
  }
})

const formatDateWithDefault = (value) => (value ? formatDate(value) : 'Non renseigné')

const { calls, sentEmails, upcomingEmails, loading } = useQuoteClientHistory(toRef(props, 'email'), toRef(props, 'siret'))
</script>
